import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import SeriesListItem from "../components/SeriesListItem";
import Loading from "./Loading";
import PageHeader from "../components/PageHeader";

export default function Series(){
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]); // series
  const [comments, setComments] = useState([]); // comments
  const [allBlogs, setAllBlogs] = useState([]); // all blogs in series
  const [activeTab, setActiveTab] = useState("comments");

  //FETCH COMMENTS
  const fetchComments = async () => {
    try {
      const response = await fetch(`https://imajin.dev/api/query-a-database-comment`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });
  
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
  
      const result = await response.json();
      const filtered = (result || []).filter(
        (c) => c.properties?.Blog?.rich_text?.[0]?.plain_text !== "/library"
      );

      // console.log(filtered);
      
      setComments(filtered);
    } catch (error) {
      console.error("Error fetching comments:", error.message);
    }
  };

  //FETCH SERIES
  const fetchData = async () => {
    try {
      const response = await fetch(`https://imajin.dev/api/query-a-database-series`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });
  
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
  
      const result = await response.json();
    
      setData(result);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  useEffect( () => {
    fetchData();
    fetchComments();
  }, []);

  useEffect( () => {
    const structured = data.flatMap(item => (
      item.properties?.Blogs?.relation?.map((blogRelation, index) => ({
        id: blogRelation.id,
        title: item.properties?.Rollup?.rollup?.array?.[index]?.title?.[0]?.plain_text || ""
      })) ?? []
    ));

    setAllBlogs(structured);
  }, [data])

  return(
    <>
      { loading ? <Loading/> :
        <div className = "page">
          {/* <Console text = { consoleMsg }/> */}

          <PageHeader
            title = "Blog"
            date = { `${data.length} Topics` }
            description = "I like to break down things until I understand them, and usually that is a lot of break downs. I hope my thought process can help others too."
            // color = "var(--ptB)"
          />

          <div className = "seriesTitles"
            style={{
            display: "flex",
            gap: "24px",
            justifyContent : "center",
            marginTop : "24px",
            }}
          >
            { data.map( ( item ) => (
              <div
                key={item.id}
                style={{
                  width : "48px",
                  height: "400px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
              <Link to = {`/series/${item.id}`}
                style = { { 
                  textDecoration : "none",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  height: "100%",
                } }
                className="a"
              >
                {/* TITLE (natural height from rotated text) */}
                <div
                  className = "seriesTitle"
                  style={{
                    // width : "48px",
                    margin: 0,
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "center",
                    // '--hover-color' : item.properties.background?.rich_text?.[0]?.plain_text || "var(--black16)",
                  }}
                >
                  <h3
                    className="heading"
                    style={{
                      display: "inline-block",
                      writingMode: "vertical-rl",   // ← IMPORTANT
                      textOrientation: "mixed",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {item.properties.Name.title[0]?.plain_text}
                  </h3>
                </div>

                {/* LINE fills remaining space */}
                <div
                  style={{
                    flex: 1,
                    width: "1px",
                    backgroundColor: "var(--black56)",
                  }}
                />

                {/* COUNT */}
                <p className = "meta">
                  {/* { counts[item.id] ?? (item.properties.Blogs?.relation?.length || 0) } */}
                </p>
                </Link>

              </div>
            ))}
          </div>

          <br/><br/>

          <div>
            <div role="tablist" aria-label="Series tabs" style={{ display: "flex", gap: "8px", marginBottom: "16px" }}>
              <button
                onClick={() => setActiveTab("comments")}
                aria-selected={activeTab === "comments"}
                style={{
                  paddingBottom: "4px",
                  background : "transparent",
                  border : "none",
                  borderBottom: activeTab === "comments" ? "1px solid var(--black40)" : "1px solid transparent",
                  cursor: "pointer"
                }}
              >
                Comments ({comments.length})
              </button>

              <button
                onClick={() => setActiveTab("full")}
                aria-selected={activeTab === "full"}
                style={{
                  paddingBottom: "4px",
                  background : "transparent",
                  border : "none",
                  borderBottom: activeTab === "full" ? "1px solid var(--black40)" : "1px solid transparent",
                  cursor: "pointer"
                }}
              >
                Full List ({allBlogs.length})
              </button>
            </div>

            <div>
              {activeTab === "comments" && (
                <div>
                  {comments.map((comment, index) => (
                    <div className="commentContainer" style = { { background : "var(--bgGrey)" }} key={index}>
                      <span className="bubble1" style = { { background : "var(--bgGrey)" }}/>
                      <span className="bubble2" style = { { background : "var(--bgGrey)" }}/>

                      <div style={{ display: "flex", flexDirection: "row", gap: "4px" }}>
                        <p className="tiny">{comment.properties.Name.title[0].plain_text} </p>
                        <p className="tiny" style={{ color: "var(--black40)" }}>says,</p>
                      </div>

                      <pre>{comment.properties.Comment.rich_text[0].plain_text}</pre>

                      <p className="meta2">{comment.properties.Date.formula.string}</p>
                      
                      <Link to={`/blog/${comment.properties.Page.rich_text[0].plain_text}`}>
                        <p className="meta2">{comment.properties.Blog?.rich_text[0]?.plain_text}</p>
                      </Link>
                    </div>
                  ))}
                </div>
              )}

              {activeTab === "full" && (
                <div style={{ marginTop: "8px" }}>
                  {allBlogs.map((item) => (
                    <Link key={item.id} to={`/blog/${item.id}`} state={{ textDecoration: "none" }}>
                      <p style={{ padding: "4px 0px", textDecoration: "none" }} className="a">{item.title}</p>
                    </Link>
                  ))}
                </div>
              )}
            </div>
          </div>

        </div>
      }
    </>
  );
}